$(document).ready(function() {
	if ($('.socialMedias.share').length) {

		// -- Functions --

		function getWindowSettings(width, height){
			return [
			  'resizable,scrollbars,status',
			  'width=' + width,
			  'height=' + height,
			  'top=' + parseFloat((window.innerHeight/2) - (height/2)),
			  'left=' + parseFloat((window.innerWidth/2) - (width/2)),
			].join();
		}

		function openShareWindow(btn, winTitle, winSettings) {
			var href = btn.attr('href');
			var title = encodeURIComponent(btn.attr('data-title'));
			var shareUrl = '';

			if (winTitle === 'ShareOnTwitter') {
				var hashtags = 'energolux';
				// var via = 'energolux';
				shareUrl = 'https://twitter.com/intent/tweet?url=' + href + '&text=' + title + '&hashtags=' +  hashtags;

			} else if (winTitle === 'ShareOnlinkedin') {
				shareUrl = 'http://www.linkedin.com/shareArticle?mini=true&url=' + href + '&title=' + title;
			}

			btn.on('click', function(e) {
			  e.preventDefault();
			  var win = window.open(shareUrl, winTitle, winSettings);
			  win.opener = null;
			});
		}


		// -- Twitter --

		var twitterShareBtn = $('.btn--share.twitter');
		var twitterSettings = getWindowSettings(500, 254);
		openShareWindow(twitterShareBtn, 'ShareOnTwitter', twitterSettings);


		// -- Linkedin --
		
		var linkedinShareBtn = $('.btn--share.linkedin');
		var linkedinSettings = getWindowSettings(500, 500);
		openShareWindow(linkedinShareBtn, 'ShareOnlinkedin', linkedinSettings);


		// -- Facebook --

	  $.ajaxSetup({ cache: true });
	  $.getScript('https://connect.facebook.net/en_US/sdk.js', function(){
	    FB.init({
	      appId: '942891596285932',
	      version: 'v11.0',
	      xfbml: false,
	      autoLogAppEvents: true,
	    });

	    $('.btn--share.facebook').on('click', function(e){
	    	e.preventDefault();

				FB.ui({
				  method: 'share',
				  display: 'popup',
			    href: $(this).attr('href'),
				  mobile_iframe: true,
				}, function(response){
				  console.log(response);
				});

	    });
	  });
	  
	}
});